import * as React from 'react';
import { getColorValue } from '../utilities/color';

function Speed(props) {
  const green = getColorValue('illustrationGreen');
  const textColor = getColorValue('illustrationLine');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <g fill={green}>
        <path d="m204.38 37.07 54.86 99.6-54.33 101.73h-62.85l61.79-102.8-63.92-99.6s63.65 1.86 64.45 1.07z" />
        <path d="m139.961 82.6698 29.84 54.2502-29.55 55.41h-63.7004l33.6004-55.99-34.7604-54.2502s64.1404 1.02 64.5704.58z" />
        <path d="m181.569 58.2101 43.22 78.5799-42.8 80.26h-78.69l48.67-81.1-50.35-78.5799s79.32 1.47 79.95.84z" />
      </g>
      <path
        d="m140.25 192.33 29.55-55.41-29.84-54.2501c-.17.17-10.11.12-22.14 0l34.14 53.2901-33.84 56.38h22.12z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m181.99 217.05 42.8-80.26-43.22-78.5798c-.25.25-12.53.17-27.4-.01l49.68 77.4198-48.95 81.44h27.09z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m41.7695 69.2202c-2 .12-2 1.23 0 1.35 2.83.17 5.81.25 9.64.26 4.34-.05 5.42-.28 8.36-.26 4.97 0 13.35.31 15.37.39.3.01.6.01.9 0 2.14-.04 11.52-.21 19.6-.13h11.0805c4.36 0 7.61-.12 10.81-.33 1.76-.12 1.76-1.09 0-1.2-3.2-.21-6.45-.33-10.81-.33-1.69 0-5.22-.27-10.2005-.31-.81 0-1.62.01-2.43.05-6.94.36-15.96.26-15.96.26h-26.73c-3.83 0-6.81.1-9.64.26z"
        fill={textColor}
      />
      <path
        d="m16.35 163.611c-1.8.12-1.8 1.23 0 1.35 2.56.17 5.24.25 8.69.26 3.91-.05 4.88-.28 7.53-.26 4.48 0 12.03.31 13.85.39h.81c1.93-.04 10.39-.21 17.67-.13h9.99c3.93 0 6.86-.12 9.74-.33 1.58-.12 1.58-1.09 0-1.2-2.88-.21-5.82-.33-9.74-.33-1.53 0-4.71-.27-9.19-.31-.73 0-1.46 0-2.19.05-6.26.36-14.38.26-14.38.26h-24.09c-3.45 0-6.14.1-8.69.26z"
        fill={textColor}
      />
      <path
        d="m33.7901 146.951c-2.03.12-2.03 1.23 0 1.35 2.88.17 5.9.25 9.78.26 4.4-.05 5.5-.28 8.48-.26 5.04 0 13.55.31 15.6.39h.91c2.17-.04 11.69-.21 19.89-.13h11.25c4.4199 0 7.7299-.12 10.9699-.33 1.78-.12 1.78-1.09 0-1.2-3.24-.21-6.55-.33-10.9699-.33-1.72 0-5.3-.27-10.35-.31-.82 0-1.65 0-2.46.05-7.05.36-16.2.26-16.2.26h-27.12c-3.89 0-6.91.1-9.78.26z"
        fill={textColor}
      />
    </svg>
  );
}

export default Speed;
